import { Stack, useTheme } from '@mui/material';
import {
  GenSearch,
  GenSelectTree,
} from '@pinnacleautomotive/clarity-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  currentUserCompanyId,
  selectUserCompanies,
} from '../../../redux/selectors/userDataSelectors';

export default function Filters({ onChange }) {
  const { t } = useTranslation('users');
  const companyId = useSelector(currentUserCompanyId);
  const [level, setLevel] = useState(companyId);
  const [levels, setLevels] = useState([companyId]);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const companies = useSelector(selectUserCompanies);

  const handleChangeLevel = newLevel => {
    setLevel(newLevel);

    const newLevels = companies
      .filter(
        company =>
          company.companyId === newLevel || company.parentCompanyId === newLevel
      )
      .map(company => company.companyId);

    setLevels(newLevels);
    onChange({ level: newLevels, searchQuery });
  };

  const hangleChangeSearch = newSearchQuery => {
    setSearchQuery(newSearchQuery);
    onChange({ level: levels, searchQuery: newSearchQuery });
  };

  return (
    <Stack direction="row" justifyContent="start" gap={2} flexWrap="wrap">
      <GenSearch
        placeholder={t('searchPlaceholder')}
        searchTerm={hangleChangeSearch}
        sx={{
          order: 0,
          width: '100%',
          [theme.breakpoints.up('lg')]: {
            width: '300px',
          },
          '& form': { margin: '0px !important', height: '100%' },
        }}
      />
      <Stack
        sx={{
          width: '100%',
          [theme.breakpoints.up('lg')]: {
            width: '300px',
          },
        }}
      >
        <GenSelectTree
          label={t('level')}
          items={companies}
          parentField="parentCompanyId"
          idField="companyId"
          textField="name"
          selectedItemId={level}
          onChange={handleChangeLevel}
          disabled={companies?.length <= 1}
          sx={{
            bgcolor: 'background.paper',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
            },
          }}
          size="small"
        />
      </Stack>
    </Stack>
  );
}
